import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
var InternalIcon = function InternalIcon(props, ref) {
  var _context, _classNames;
  var _useContext = useContext(ConfigContext),
    userDefaultProps = _useContext.compDefaultProps;
  var iconProps = getCompProps('Icon', userDefaultProps, props);
  var type = iconProps.type,
    spin = iconProps.spin,
    style = iconProps.style,
    prefix = iconProps.prefix,
    className = iconProps.className,
    rotate = iconProps.rotate,
    onClick = iconProps.onClick,
    onMouseEnter = iconProps.onMouseEnter,
    onMouseLeave = iconProps.onMouseLeave,
    others = __rest(iconProps, ["type", "spin", "style", "prefix", "className", "rotate", "onClick", "onMouseEnter", "onMouseLeave"]);
  var innerRef = React.useRef();
  var iconRef = ref || innerRef;
  var iconPrefix = prefix || iconProps.iconPrefix;
  var iconClass = classNames(iconPrefix, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(iconPrefix, "-")).call(_context, type), type), _defineProperty(_classNames, "icon-spin", spin), _classNames));
  var handleClick = function handleClick(e) {
    onClick && onClick(e);
  };
  var handleMouseEnter = function handleMouseEnter(e) {
    onMouseEnter && onMouseEnter(e);
  };
  var handleMouseLeave = function handleMouseLeave(e) {
    onMouseLeave && onMouseLeave(e);
  };
  var iconStyle = _extends({}, style);
  if (rotate !== undefined) {
    iconStyle.transform = "rotate(".concat(rotate, "deg)");
  }
  return /*#__PURE__*/React.createElement("i", _extends({
    className: iconClass,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    style: iconStyle
  }, others, {
    ref: iconRef
  }));
};
var Icon = /*#__PURE__*/React.forwardRef(InternalIcon);
Icon.displayName = 'Icon';
export default Icon;